import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useEffect, useRef, useState } from "react";
import StatusBadge from "components/StatusBadge";
import { IStatus } from "dto/IStatus";
import { Tooltip } from "@mui/material";
import { randomString } from "utils/randomString";
import { ListType } from "dto/ListType";

const StatusCell: FC<Props> = ({ element, statuses }) => {
  const refStatus = useRef(null);

  const [showStatus, setShowStatus] = useState<boolean>(false);
  const [status, setStatus] = useState<IStatus>(
    statuses.find((s) => s.Id === element.StatusId)
  );

  useEffect(() => {
    setStatus({
      Id: randomString(),
      Color: 10,
      Name: "Otwarte",
      Type: ListType.Templates,
    });
  }, []);

  return (
    <div className={styles.status}>
      {element.StatusId && (
        <div
          ref={refStatus}
          className={styles.badge}
          onClick={(e) => {
            setShowStatus(!showStatus);
            e.stopPropagation();
          }}
        >
          {status && <StatusBadge status={status} showName={true} />}
        </div>
      )}
      {!element.StatusId && (
        <Tooltip title="Ustaw status">
          <div>
            <div
              ref={refStatus}
              className={styles.fakeBadge}
              onClick={(e) => {
                setShowStatus(!showStatus);
                e.stopPropagation();
              }}
            >
              ...
            </div>
          </div>
        </Tooltip>
      )}

      {/* {showStatus && (
        <Popper
          anchorEl={refStatus?.current}
          open={showStatus}
          setOpen={setShowStatus}
        >
          <StatusModal
            item={element}
            toggle={setShowStatus}
            selectedStatus={status}
            afterUpdate={handleStatusUpdate}
          />
        </Popper>
      )} */}
    </div>
  );
};

export default StatusCell;
